import React, { useMemo } from "react";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, isFromMobileApp, children }) {
  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  const handleBackClick = (e) => {
    if (isFromMobileApp) {
      e.preventDefault();
      window.GameStatus?.postMessage?.("navigate_back");
      return;
    }
    onBack?.();
  };

  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}>
        <img src={imageUrl} alt="Header" className="logo-holder" />
      </a>
        {!isFromMobileApp && (
          <div className="back-holder">
            <button onClick={handleBackClick} className="back-default">Back</button>
          </div>
        )}
       
      </header>
      {children}
    </>
  );
}

export default DDDUI;